import produce from 'immer';
import { locationList, locationRetrieve } from './actions';

/* eslint-disable default-case */

const initialState = {
  loading: false,
  error: null,
  items: [],
  item: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case locationList.TRIGGER:
    case locationRetrieve.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case locationList.SUCCESS:
      draft.items = payload;
      break;
    case locationRetrieve.SUCCESS:
      draft.item = payload;
      break;
    case locationList.FAILURE:
    case locationRetrieve.FAILURE:
      draft.error = payload;
      break;
    case locationList.FULFILL:
    case locationRetrieve.FULFILL:
      draft.loading = false;
      break;
    // no default
  }
}, initialState);

export default reducer;
